import { render } from "./chartB.vue?vue&type=template&id=d3482a98"
import script from "./chartB.vue?vue&type=script&lang=ts"
export * from "./chartB.vue?vue&type=script&lang=ts"
script.render = render

export default script